export const mutations = {
  STORE_BONDTRACKINGS(state, bondtrackings) {
    state.bondtrackings = bondtrackings;
  },
  STORE_BONDTRACKING_UPDATE(state, bondtrackingId) {
    let Bondtracking = state.bondtrackings.find(function(bondtracking) {
      return bondtracking.id === bondtrackingId;
    });
    state.systemBondtracking = Bondtracking;
  }
};
export default mutations;



// WEBPACK FOOTER //
// ./src/vuex/modules/bondtrackings/mutations.js